// extracted by mini-css-extract-plugin
export var brand = "_2k-9";
export var button = "_2k-0";
export var chevron = "_2k-v";
export var chevronButton = "_2k-w";
export var content = "_2k-n";
export var danger = "_2k-g";
export var dangerOutlined = "_2k-h";
export var dark = "_2k-l";
export var darkTheme = "_2k-c";
export var extraSmall = "_2k-4";
export var fullWidth = "_2k-8";
export var ghost = "_2k-d";
export var gray = "_2k-t";
export var icon = "_2k-p";
export var iconButton = "_2k-s";
export var iconButtonBorder = "_2k-x";
export var iconButtonBorderDark = "_2k-y";
export var iconButtonBorderLight = "_2k-z";
export var iconLeft = "_2k-q";
export var iconRight = "_2k-r";
export var large = "_2k-1";
export var light = "_2k-m";
export var medium = "_2k-2";
export var micro = "_2k-5";
export var nano = "_2k-7";
export var outlined = "_2k-k";
export var pending = "_2k-a";
export var primary = "_2k-i";
export var shadow = "_2k-o";
export var small = "_2k-3";
export var solidLight = "_2k-e";
export var solidLightBrand = "_2k-f";
export var spinner = "_2k-u";
export var transparent = "_2k-j";
export var warning = "_2k-b";
export var wideNano = "_2k-6";